import { OptionI } from '@/utils/forms/optionBuilders'

/**
 * Handles selection change, passing full option object(s) to form.
 */
export const handleSelectChange = (
  selected: OptionI | OptionI[] | null,
  isMulti: boolean,
  onChange: (value: OptionI | OptionI[] | null) => void
): void => {
  if (isMulti) {
    onChange(Array.isArray(selected) ? selected : [])
  } else {
    onChange(selected as OptionI | null)
  }
}

/**
 * Handles chip removal from selection.
 */
export const handleChipRemove = (
  valueToRemove: string,
  currentValue: OptionI | OptionI[] | null | undefined,
  isMulti: boolean,
  onChange: (value: OptionI | OptionI[] | null) => void
): void => {
  if (isMulti && Array.isArray(currentValue)) {
    onChange(currentValue.filter((opt) => opt.value !== valueToRemove))
  } else {
    onChange(null)
  }
}

/**
 * Handles Select All functionality for filtered options.
 * Toggles selection of visible/filtered options while preserving other selections.
 */
export const handleSelectAll = (
  filteredOptions: readonly OptionI[],
  currentValue: OptionI | OptionI[] | null | undefined,
  onChange: (value: OptionI[]) => void
): void => {
  const currentSelection = Array.isArray(currentValue) ? currentValue : []
  const selectedValues = new Set(currentSelection.map((v) => v.value))

  // Check if all filtered options are already selected
  const isAllFilteredSelected = filteredOptions.every((opt) =>
    selectedValues.has(opt.value)
  )

  if (isAllFilteredSelected) {
    // Deselect only the filtered options, keep others selected
    const remainingOptions = currentSelection.filter(
      (v) => !filteredOptions.some((f) => f.value === v.value)
    )
    onChange(remainingOptions)
  } else {
    // Add filtered options to current selection (avoid duplicates)
    const newSelection = [
      ...currentSelection,
      ...filteredOptions.filter((f) => !selectedValues.has(f.value)),
    ]
    onChange(newSelection)
  }
}
